var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { isDev, TravelError } from "@travel/shared/utils";
import { TravelAPI } from "@travel/shared/data-access";
import { mutateLocation } from "@travel/shared/locations/utils";
function computeLocationPlural(type) {
    switch (type) {
        case "airport":
            return "airports";
        case "hotel":
            return "hotels";
        case "geo":
            return "geo";
        case "poi":
            return "pointofinterest";
        default:
        case "city":
            return "cities";
    }
}
export var getLocation = TravelAPI({
    name: "location:fetch",
    url: function (request) {
        return "/search/lookup/".concat(computeLocationPlural(request.type), "/").concat(request.type === "geo" ? request.id.replace("x", "$") : request.id, "?ver=4");
    },
    baseURL: isDev
        ? "https://ppn-feed.herokuapp.com"
        : "https://api-prod.getfeedz.com",
    mutate: function (data, request, options, url) {
        var _a;
        var foundLocation = (_a = data === null || data === void 0 ? void 0 : data.results) === null || _a === void 0 ? void 0 : _a[0];
        if (!foundLocation) {
            throw new TravelError({
                message: "Location not found",
                info: data,
                request: request,
                url: url,
            });
        }
        var location = mutateLocation(foundLocation);
        return location;
    },
});
export var getLocationSuggestions = TravelAPI({
    name: "location:suggestions",
    url: function (request) {
        return "/search/autosuggestv4/".concat(request.query
            .trim()
            .toLowerCase(), "?page=0&hitsPerPage=10");
    },
    mutate: function (data) {
        var e_1, _a, e_2, _b;
        var list = [];
        if (data.results) {
            try {
                for (var _c = __values(data.results), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var location_1 = _d.value;
                    list.push(mutateLocation(location_1));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else {
            for (var categoryName in data) {
                try {
                    for (var _e = (e_2 = void 0, __values(data[categoryName])), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var location_2 = _f.value;
                        list.push(mutateLocation(location_2));
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        return {
            list: list,
            totalListCount: list.length,
        };
    },
});
export var getCountryStates = TravelAPI({
    url: function (countryCode) { return "/".concat(countryCode); },
    baseURL: "/locations/states",
});
